import styled from 'styled-components';
import is from 'styled-is';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import colors from '@honeybook/hbui/dist/styles/colors';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { truncatedText } from '@honeybook/hbui/dist/styles/mixins';
import { EyeContainer } from '../Components/PreviewEye';

export const SidebarFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
`;

// TODO: unify designs to use only this one
export const SidebarField = styled.div`
    display: flex;
    align-items: center;
    height: 42px;
`;

export const Divider = styled.div`
    width: 300px;
    height: 1px;
    background: ${colors.neutral200};
    margin: ${spacing[20]} -${spacing[20]};
`;

const headerHeight = 64;
const sidebarMarginTop = 20;

export const SideBarContainer = styled.div<{ width: number }>`
    position: fixed;
    display: flex;
    flex-direction: column;
    top: calc(${headerHeight}px + ${sidebarMarginTop}px);
    right: 0px;
    width: ${props => props.width}px;
    height: calc(100% - ${headerHeight + 2 * sidebarMarginTop}px);
    background-color: ${colors.white};
    box-shadow: 0 10px 20px 0 rgba(0, 18, 71, 0.08),
        0 1px 4px 0 rgba(0, 18, 71, 0.05);
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
`;

export const StepSideBarActionOccured = styled(HBText)`
    padding: 20px 20px 0;
    text-align: center;
    display: block;
`;

export const SideBarContentContainer = styled.div<{ isDone: boolean }>`
    flex: 1;
    height: 100%;
    overflow-y: auto;
    ${is('isDone')`
        *:not(${StepSideBarActionOccured}) {
            fill: ${colors.neutral400} !important;
            color: ${colors.neutral600} !important;
        }
    `}
`;

export const SideBarTitle = styled.span`
    border-bottom: 1px solid ${colors.neutral200};
    padding: ${spacing[20]};
`;

export const SideBarSection = styled.div`
    padding: ${spacing[12]} ${spacing[20]} ${spacing[20]};
    border-bottom: 1px solid ${colors.neutral200};
    &:last-child {
        border: 0;
    }
`;

export const SideBarSectionWhen = styled.div`
    padding: ${spacing[12]} ${spacing[20]} ${spacing[12]};
    border-bottom: 1px solid ${colors.neutral200};
    &:last-child {
        border: 0;
    }
`;

export const TemplatesList = styled.div`
    padding: ${spacing[12]} ${spacing[0]};
`;

export const TemplatesListItem = styled(HBText).attrs({
    type: 'Body5DarkPrimary'
})`
    flex: 1;
    ${truncatedText}
`;

export interface TemplatesListItemProps {
    isSelected?: boolean;
    isEyeHovered?: boolean;
}

export const TemplatesListItemContainer = styled.div<TemplatesListItemProps>`
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    gap: 6px;
    position: relative;
    padding: 7px 12px 7px 20px;
    cursor: pointer;
    transition: background-color 150ms;
    ${EyeContainer} {
        display: none;
    }
    &:hover {
        background-color: ${colors.neutral100};
        ${EyeContainer} {
            display: flex;
        }
    }
    ${is('isSelected')`
        && {
            background-color: ${colors.blue20}0d;
            ${TemplatesListItem} {
                font-weight: 600;
            }
        }
    `}
    ${is('isEyeHovered')`
        &&& {
            background-color: transparent;
        }
    `}
`;

export const EDIT_AUTOMATION_TOOLTIP =
    'Click EDIT in the top right to make any changes';
